/* ============================================================
   INDIGREY REDESIGN — shared runtime (window.IG)
   Ports the prototype's client logic (toast, adaptive-brightness
   icon coloring, swipe galleries, quick-add size picker, wishlist
   hearts) onto Shopify backends. Prototype = source of truth.
   ============================================================ */
(function () {
  if (window.IG) return;
  var IG = window.IG = {};

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- TOAST (prototype-exact: dark pill, ~1.8s) ---------- */
  var toastEl, toastTimer;
  IG.toast = function (msg) {
    if (!toastEl) {
      toastEl = document.getElementById('ig-rd-toast');
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.id = 'ig-rd-toast';
        document.body.appendChild(toastEl);
      }
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  };

  /* ---------- CART ---------- */
  IG.refreshCartCount = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          if (el.classList.contains('cart-count-drawer')) {
            el.innerHTML = '(' + cart.item_count + ')';
          } else {
            el.innerHTML = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
            el.classList.toggle('hidden', cart.item_count === 0);
          }
        });
        return cart;
      });
  };

  /* ---------- viewport stability (site-wide) ----------
     Async DOM changes on the bag / wishlist move content above the scroll
     position and jerk the viewport up or down. Rather than scrolling back
     AFTER a jump, these helpers hold the viewport perfectly still: the scroll
     position is compensated synchronously (before the browser paints) against a
     live anchor at the top of the viewport, and only the affected element is
     collapsed / reflowed. Root fix, no visible correction. */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CAN_ANIM = typeof Element !== 'undefined' && !!Element.prototype.animate;
  function scrollEl() { return document.scrollingElement || document.documentElement; }
  function outerH(el) {
    var cs = getComputedStyle(el);
    return el.offsetHeight + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
  }
  // Set scroll instantly even under `scroll-behavior: smooth` (base theme sets it).
  function instantScrollTop(y) {
    var root = document.documentElement, prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    scrollEl().scrollTop = y;
    root.style.scrollBehavior = prev;
  }
  // A fixed/sticky ancestor doesn't move when content reflows, so it's useless
  // as a scroll anchor — its rect delta would read 0 and we'd skip compensation.
  function isPinned(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  }
  // The topmost persistent, in-flow element near the viewport's top edge, past a
  // sticky header and skipping the subtree about to be removed. Its on-screen
  // position is what we hold fixed.
  function topAnchor(exclude) {
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var x = Math.max(1, Math.min(vw / 2, vw - 1));
    var ys = [2, Math.round(vh * 0.15), Math.round(vh * 0.4)];
    for (var j = 0; j < ys.length; j++) {
      var el = document.elementFromPoint(x, ys[j]);
      while (el && exclude && (el === exclude || exclude.contains(el))) {
        el = exclude.nextElementSibling || exclude.previousElementSibling || exclude.parentElement;
      }
      if (el && el !== document.body && el !== document.documentElement && !isPinned(el)) return el;
    }
    return null;
  }
  // Run a synchronous DOM mutation while keeping the viewport visually fixed.
  IG.preserveViewport = function (mutate, opts) {
    opts = opts || {};
    var anchor = opts.anchor || topAnchor(opts.exclude);
    var t0 = (anchor && anchor.isConnected) ? anchor.getBoundingClientRect().top : null;
    mutate();
    if (anchor && anchor.isConnected && t0 != null) {
      var d = anchor.getBoundingClientRect().top - t0;
      if (d) instantScrollTop(scrollEl().scrollTop + d);
    }
  };
  // Collapse a stacked row (a bag line) to nothing, then remove it. A row above
  // the fold is removed instantly with scroll compensation (invisible); a
  // visible row collapses smoothly while everything above it — the viewport —
  // stays put, so nothing jumps.
  IG.collapseRow = function (el, cb) {
    if (!el) { if (cb) cb(); return; }
    var rect = el.getBoundingClientRect();
    if (rect.top < 0 || REDUCED || !CAN_ANIM) {
      var h = outerH(el), above = rect.top < 0;
      if (el.parentNode) el.parentNode.removeChild(el);
      if (above) instantScrollTop(scrollEl().scrollTop - h);
      if (cb) cb();
      return;
    }
    var done = false;
    function finish() { if (done) return; done = true; if (el.parentNode) el.parentNode.removeChild(el); if (cb) cb(); }
    var oh = el.offsetHeight, cs = getComputedStyle(el);
    el.style.overflow = 'hidden'; el.style.boxSizing = 'border-box';
    var a = el.animate(
      [{ height: oh + 'px', opacity: 1, marginTop: cs.marginTop, marginBottom: cs.marginBottom, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom },
       { height: '0px', opacity: 0, marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' }],
      { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }
    );
    a.onfinish = finish; a.oncancel = finish;
    setTimeout(finish, 520);
  };
  // Drop a card out of a CSS grid (recs / wishlist): fade it, remove it while the
  // viewport is held, then FLIP the survivors into their new slots. FLIP deltas
  // are measured in document space so scroll compensation never doubles up.
  IG.dropCard = function (el, cb) {
    if (!el) { if (cb) cb(); return; }
    var grid = el.parentNode;
    if (!grid) { if (cb) cb(); return; }
    var done = false;
    function reflow() {
      if (done) return; done = true;
      var y = scrollEl().scrollTop;
      var sibs = [].slice.call(grid.children).filter(function (x) { return x !== el && x.style.display !== 'none'; });
      var first = sibs.map(function (x) { var r = x.getBoundingClientRect(); return { l: r.left, t: r.top + y }; });
      IG.preserveViewport(function () { if (el.parentNode) grid.removeChild(el); }, { exclude: el });
      if (!CAN_ANIM) { if (cb) cb(); return; }
      var y2 = scrollEl().scrollTop;
      sibs.forEach(function (x, i) {
        var r = x.getBoundingClientRect();
        var dx = first[i].l - r.left, dy = first[i].t - (r.top + y2);
        if (!dx && !dy) return;
        x.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
                  { duration: 420, easing: 'cubic-bezier(.4,0,.2,1)' });
      });
      if (cb) cb();
    }
    if (REDUCED || !CAN_ANIM) { reflow(); return; }
    var f = el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.97)' }],
                       { duration: 280, easing: 'ease', fill: 'forwards' });
    f.onfinish = reflow; f.oncancel = reflow;
    setTimeout(reflow, 340);
  };

  // Add a variant to cart WITHOUT triggering the theme's form-submit intercept.
  // sizeLabel (optional) drives the prototype toast copy "Added to bag · Size M".
  IG.addToCart = function (variantId, qty, sizeLabel) {
    var body = { id: variantId, quantity: qty || 1 };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          IG.toast((res.data && (res.data.description || res.data.message)) || 'Could not add');
          return Promise.reject(res.data);
        }
        return IG.refreshCartCount().then(function () {
          IG.toast(sizeLabel ? 'Added to bag · Size ' + sizeLabel : 'Added to bag');
          return res.data;
        });
      });
  };

  /* ---------- ADAPTIVE ICON COLOR (canvas brightness) ----------
     Ported verbatim from the prototype: samples 4 image regions and
     returns legible icon colors. cb receives {left,right,bl,br} of
     {icon,bg}. Falls back to white on CORS/error (prototype behavior). */
  var _analyzed = {};
  IG.controlColors = function (b) {
    if (b == null) return { icon: '#FFFFFF', bg: 'rgba(0,0,0,.10)' };
    return b < 140 ? { icon: '#FFFFFF', bg: 'rgba(255,255,255,.11)' }
                   : { icon: '#1a1714', bg: 'rgba(0,0,0,.07)' };
  };
  IG.analyzeImage = function (url, cb) {
    if (!url) return;
    if (_analyzed[url]) { cb(_analyzed[url]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = 40, h = Math.max(1, Math.round(w * img.height / img.width)) || 53;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
        var regions = { left: [0, h * 0.35, w * 0.2, h * 0.3], right: [w * 0.8, h * 0.35, w * 0.2, h * 0.3], bl: [0, h * 0.76, w * 0.3, h * 0.24], br: [w * 0.7, h * 0.76, w * 0.3, h * 0.24] };
        var out = {};
        Object.keys(regions).forEach(function (key) {
          var r = regions[key];
          var rx = Math.max(0, Math.floor(r[0])), ry = Math.max(0, Math.floor(r[1]));
          var rw = Math.max(1, Math.min(w - rx, Math.floor(r[2]))), rh = Math.max(1, Math.min(h - ry, Math.floor(r[3])));
          var data = ctx.getImageData(rx, ry, rw, rh).data;
          var sum = 0, n = 0;
          for (var i = 0; i < data.length; i += 4) { sum += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]; n++; }
          out[key] = n ? sum / n : 150;
        });
        var res = { left: IG.controlColors(out.left), right: IG.controlColors(out.right), bl: IG.controlColors(out.bl), br: IG.controlColors(out.br) };
        _analyzed[url] = res; cb(res);
      } catch (e) {
        var f = { left: IG.controlColors(null), right: IG.controlColors(null), bl: IG.controlColors(null), br: IG.controlColors(null) };
        _analyzed[url] = f; cb(f);
      }
    };
    img.onerror = function () {
      var f = { left: IG.controlColors(null), right: IG.controlColors(null), bl: IG.controlColors(null), br: IG.controlColors(null) };
      _analyzed[url] = f; cb(f);
    };
    img.src = url;
  };

  /* ---------- REGION SAMPLER (per-control adaptive contrast) ----------
     analyzeImage() samples four fixed thirds of the frame, which is too coarse
     for the arrows: a control can sit over a bright highlight inside an overall
     dark photograph. This samples the exact normalised rect a control occupies
     and returns its mean luminance, cached per url+rect. */
  var _regions = {};
  IG.regionBrightness = function (url, rect, cb) {
    if (!url) return;
    var key = url + '|' + rect.join(',');
    if (_regions[key] !== undefined) { cb(_regions[key]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = 64, h = Math.max(1, Math.round(w * img.height / img.width)) || 85;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
        var rx = Math.max(0, Math.floor(rect[0] * w));
        var ry = Math.max(0, Math.floor(rect[1] * h));
        var rw = Math.max(1, Math.min(w - rx, Math.round((rect[2] - rect[0]) * w)));
        var rh = Math.max(1, Math.min(h - ry, Math.round((rect[3] - rect[1]) * h)));
        var d = ctx.getImageData(rx, ry, rw, rh).data, sum = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; n++; }
        _regions[key] = n ? sum / n : 150;
      } catch (e) { _regions[key] = null; }   // CORS/decode failure
      cb(_regions[key]);
    };
    img.onerror = function () { _regions[key] = null; cb(null); };
    img.src = url;
  };

  /* Elegant contrast, not maximum contrast: a deep warm charcoal that belongs
     to the palette rather than pure black, and a soft off-white rather than
     #FFF. A hysteresis band keeps the choice stable — once a colour is chosen
     the luminance must travel well past the midpoint before it flips, so an
     arrow crossing a boundary region never oscillates between frames. */
  IG.ARROW_ON_LIGHT = '#2A2521';
  IG.ARROW_ON_DARK  = '#F2EFEA';
  IG.arrowColor = function (lum, previous) {
    if (lum == null) return previous || IG.ARROW_ON_DARK;  // fallback stays legible
    var MID = 150, BAND = 18;
    if (previous === IG.ARROW_ON_DARK)  return lum > MID + BAND ? IG.ARROW_ON_LIGHT : IG.ARROW_ON_DARK;
    if (previous === IG.ARROW_ON_LIGHT) return lum < MID - BAND ? IG.ARROW_ON_DARK  : IG.ARROW_ON_LIGHT;
    return lum > MID ? IG.ARROW_ON_LIGHT : IG.ARROW_ON_DARK;
  };

  // Apply adaptive colors to a card's control icons (bag=bl, heart=br).
  // opts.skipArrows keeps the gallery arrows at the colour resolved on first
  // paint. Re-sampling them on every image change made the chevron flip
  // between white and ink as the gallery cycled, which reads as the arrow
  // slowly filling with white and then snapping back once per loop. The
  // arrows are a persistent control, so their appearance must not depend on
  // whichever frame is currently showing.
  IG.paintCardIcons = function (card, opts) {
    opts = opts || {};
    var img = card.querySelector('.ig-rd-card__img');
    if (!img) return;
    var url = img.getAttribute('src');
    IG.analyzeImage(url, function (res) {
      var bag = card.querySelector('.ig-rd-card__bag svg');
      var heart = card.querySelector('.ig-rd-card__heart svg');
      if (bag) bag.style.stroke = res.bl.icon;
      if (heart && !card.querySelector('.ig-rd-card__heart').classList.contains('is-saved')) heart.style.stroke = res.br.icon;
      if (opts.skipArrows) return;
      var la = card.querySelector('.ig-rd-card__arrow--l svg');
      var ra = card.querySelector('.ig-rd-card__arrow--r svg');
      if (la) la.style.stroke = res.left.icon;
      if (ra) ra.style.stroke = res.right.icon;
    });
  };

  /* ---------- IMAGE SWIPE (cards + PDP) ----------
     Follows finger in real time; snaps back < 40px, advances beyond.
     onStep(dir) is called to change image. */
  IG.attachSwipe = function (el, opts) {
    opts = opts || {};
    var startX = null, dragging = false, imgEl = opts.imgEl || el.querySelector('img');
    function down(e) {
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      dragging = true;
      if (imgEl) imgEl.style.transition = 'none';
    }
    function move(e) {
      if (!dragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      var dx = x - startX;
      if (imgEl) imgEl.style.transform = 'translateX(' + dx + 'px)';
    }
    function up(e) {
      if (!dragging) return;
      dragging = false;
      var x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX);
      var dx = x - startX;
      if (imgEl) {
        imgEl.style.transition = 'transform .32s cubic-bezier(.45,0,.55,1)';
        imgEl.style.transform = 'translateX(0)';
      }
      if (dx < -40 && opts.onStep) opts.onStep(1);
      else if (dx > 40 && opts.onStep) opts.onStep(-1);
    }
    el.addEventListener('touchstart', down, { passive: true });
    el.addEventListener('touchmove', move, { passive: true });
    el.addEventListener('touchend', up);
    el.addEventListener('mousedown', down);
    el.addEventListener('mousemove', move);
    el.addEventListener('mouseup', up);
    el.addEventListener('mouseleave', function (e) { if (dragging) up(e); });
  };

  /* ---------- WISHLIST HEART (bare, adaptive, haptic) ----------
     Reuses window.Wishlist store; renders prototype visuals. */
  /* Heart glyphs built fresh on each state change. Same heart-card path used
     across the site; colour lives on the SVG so a brand-new node paints its
     fill immediately (like a saved heart does on load) instead of deferring
     the fill the way a mutated node does on iOS Safari. */
  var HEART_PATH = 'M10 17.2c-.2 0-.4-.07-.55-.2C7.2 14.8 5.2 13 4 11.4 2.8 9.9 2.2 8.5 2.2 7.1c0-1.9 1.5-3.5 3.5-3.5 1.4 0 2.6.8 3.3 2 .12.2.5.2.62 0 .7-1.2 1.9-2 3.3-2 2 0 3.5 1.6 3.5 3.5 0 1.4-.6 2.8-1.8 4.3-1.2 1.6-3.2 3.4-5.45 5.6-.15.13-.35.2-.55.2z';
  function heartSVG(saved) {
    // Saved = a SOLID wine heart with NO stroke; empty = a thin ink outline.
    // CRITICAL: fill/stroke go INLINE ON THE PATH, not on the <svg>. The base
    // theme sets `path { fill:#fff }`, which overrides a fill inherited from the
    // <svg> — so a heart filled only at the svg level rendered WHITE inside with
    // just the wine stroke showing (the "only the outline is wine" bug). An
    // inline style on the path itself wins over that rule, so the fill lands.
    var stroke = saved ? 'none' : '#1a1714';
    var fill = saved ? '#6d2836' : 'none';
    var sw = saved ? '0' : '1.1';
    return '<svg viewBox="0 0 20 20" width="18" height="18" style="width:18px;height:18px">' +
      '<path d="' + HEART_PATH + '" style="fill:' + fill + ';stroke:' + stroke + ';stroke-width:' + sw + '"/></svg>';
  }

  function paintHeart(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    var saved = window.Wishlist ? window.Wishlist.has(handle) : false;
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');

    /* --- PDP heart: REPLACE the node, don't mutate it ---
       Rewriting the container's innerHTML inserts a fresh SVG. iOS Safari
       paints a newly-inserted node on the same frame (identical to how a saved
       heart renders on load), so the wine fill — not just the outline — shows
       on THIS tap. Mutating an existing node's fill/opacity is what WebKit was
       deferring to the next event. Only swap when the state actually changed,
       so re-syncs don't rebuild needlessly. */
    var host = btn.querySelector('[data-ig-heart]');
    if (host) {
      var want = saved ? '1' : '0';
      if (host.getAttribute('data-saved') !== want) {
        host.setAttribute('data-saved', want);
        host.innerHTML = heartSVG(saved);
        /* force layout so the new node is rasterised now, not on the next touch */
        /* eslint-disable-next-line no-unused-expressions */
        host.offsetWidth;
        if (saved) { host.classList.remove('ig-pop'); host.offsetWidth; host.classList.add('ig-pop'); }
        else { host.classList.remove('ig-pop'); }
      }
      return;
    }

    var svg = btn.querySelector('svg');
    if (!svg) return;
    /* Hearts marked data-ig-css-heart let CSS own fill/stroke, so the state can
       transition. Inline paint would out-rank the stylesheet and freeze it. */
    if (btn.hasAttribute('data-ig-css-heart')) { svg.style.fill = ''; svg.style.stroke = ''; return; }
    /* Legacy inline path (product cards, header). BUG FIX: the old code set the
       wine stroke when saving but never restored it when un-saving, so a card's
       heart stayed wine-outlined forever and the UI disagreed with the store.
       The icon's own colour is captured once and restored on un-save — note the
       card's adaptive-brightness stroke is written to the same property, so it
       has to be remembered rather than simply cleared. */
    if (svg.dataset.baseStroke === undefined) svg.dataset.baseStroke = svg.style.stroke || '';
    svg.style.fill = saved ? '#6d2836' : 'none';
    svg.style.stroke = saved ? '#6d2836' : svg.dataset.baseStroke;
  }
  IG.syncHearts = function (root) {
    (root || document).querySelectorAll('.ig-rd-heart[data-wishlist-handle], .ig-rd-header__wish[data-wishlist-handle]').forEach(paintHeart);
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ig-rd-heart[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    // toggle() returns true when the item was just saved, false when removed —
    // drive both the haptic weight and the toast copy off that so the two
    // always agree with what actually happened.
    var saved = window.Wishlist ? window.Wishlist.toggle(handle) : false;
    // Myntra-style crisp tap: a touch heavier when saving than when removing,
    // so the "kept it" action feels more affirmative. No-op on desktop/iOS
    // (navigator.vibrate absent there); wrapped in try for locked-down UAs.
    if (navigator.vibrate) { try { navigator.vibrate(saved ? 18 : 10); } catch (x) {} }
    /* Surfaces that show their own inline confirmation opt out of the global
       toast, so the same action never announces itself twice. */
    if (!btn.hasAttribute('data-ig-no-toast')) {
      IG.toast(saved ? 'Added to wishlist' : 'Removed from wishlist');
    }
    paintHeart(btn);
    btn.dispatchEvent(new CustomEvent('ig:wish', { bubbles: true, detail: { saved: saved } }));
  });
  document.addEventListener('wishlist:updated', function () { IG.syncHearts(); IG.syncWishBadges(); });

  IG.syncWishBadges = function () {
    var n = window.Wishlist ? window.Wishlist.count() : 0;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    // header wishlist icon fill mirrors "has items"
    document.querySelectorAll('.ig-rd-header__wish svg').forEach(function (svg) {
      svg.style.fill = n > 0 ? '#6d2836' : 'none';
    });
  };

  /* ---------- QUICK-ADD SIZE PICKER OVERLAY ----------
     Toggles the pill overlay inside a card; size click adds to cart.
     data-quick-add-variants = JSON [{label,id,available}] */
  document.addEventListener('click', function (e) {
    var addbag = e.target.closest && e.target.closest('.ig-rd-card__addbag');
    if (addbag) {
      e.preventDefault(); e.stopPropagation();
      quickAdd(addbag.closest('.ig-rd-card'));
      return;
    }
    var trigger = e.target.closest && (e.target.closest('.ig-rd-card__bag') || e.target.closest('.ig-rd-card__addbag') || e.target.closest('.ig-rd-card__qa-cta'));
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      var card = trigger.closest('.ig-rd-card');
      togglePicker(card);
      return;
    }
    var backdrop = e.target.closest && e.target.closest('.ig-rd-sizepick');
    if (backdrop && backdrop === e.target) {
      backdrop.classList.remove('is-open');
      return;
    }
    var sizeBtn = e.target.closest && e.target.closest('.ig-rd-sizepick__btn');
    if (sizeBtn) {
      e.preventDefault(); e.stopPropagation();
      var card2 = sizeBtn.closest('.ig-rd-card');
      var variantId = sizeBtn.getAttribute('data-variant-id');
      var label = sizeBtn.getAttribute('data-label');
      var pick = sizeBtn.closest('.ig-rd-sizepick');
      if (pick) pick.classList.remove('is-open');
      if (!variantId) return;
      var toWishlist = card2 && card2.getAttribute('data-wishlist-quickadd') === 'true';
      var toBag = card2 && card2.getAttribute('data-cart-quickadd') === 'true';
      if (toWishlist) { wishlistAddInPlace(card2, variantId, label); return; }  // add in place — no redirect
      IG.addToCart(variantId, 1, label).then(function () {
        if (toBag) window.location.reload();        // cart rec: re-render bag with the new item
      }).catch(function () {});
    }
  });
  // Wishlist quick-add (cart recs): pick a size only when there's a real choice.
  function quickAdd(card) {
    if (!card) return;
    var avail = card.querySelectorAll('.ig-rd-sizepick__btn:not(.is-unavailable):not([disabled])');
    if (avail.length > 1) { togglePicker(card); return; }   // let the shopper choose
    var variantId, label = null;
    if (avail.length === 1) {
      variantId = avail[0].getAttribute('data-variant-id');
      label = avail[0].getAttribute('data-label');
    } else {
      variantId = card.getAttribute('data-add-variant');    // single-variant product
    }
    if (!variantId) { togglePicker(card); return; }          // safe fallback
    var toBag = card.getAttribute('data-cart-quickadd') === 'true';
    var toWish = card.getAttribute('data-wishlist-quickadd') === 'true';
    if (toWish) { wishlistAddInPlace(card, variantId, label); return; }  // add in place — no redirect
    IG.addToCart(variantId, 1, label).then(function () {
      if (toBag) window.location.reload();
    }).catch(function () {});
  }

  /* Wishlist "Add to Bag": add in place and keep the shopper on the page. The
     piece moves into the cart, a brief "Added to Cart" confirms on the card,
     then the card leaves the wishlist (never in both at once) and the grid
     reflows. No redirect — they keep browsing their saved pieces. */
  function wishlistAddInPlace(card, variantId, label) {
    if (!card || !variantId) return;
    var handle = card.getAttribute('data-product-handle');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function () {
        if (IG.refreshCartCount) IG.refreshCartCount();   // header bag count ticks up
        var wrap = card.querySelector('.ig-rd-card__imgwrap') || card.querySelector('.ig-rd-card__media') || card;
        var conf = document.createElement('div');
        conf.className = 'ig-rd-card__added';
        conf.innerHTML = '<svg width="13" height="13" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 10.5l3.2 3.2L15 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Added to Cart</span>';
        wrap.appendChild(conf);   // CSS keyframe fades it in on its own
        // hold the confirmation, then let the card leave the wishlist for the
        // bag. Removal fires `wishlist:updated`, and the wishlist page's handler
        // drops the card via IG.dropCard() — it fades and FLIPs the grid with
        // the viewport held. We do NOT pre-fade here (that would fight dropCard's
        // own fade and flash the card back in).
        setTimeout(function () {
          if (window.Wishlist && handle) window.Wishlist.remove(handle);
        }, 900);
      })
      .catch(function () { if (IG.toast) IG.toast('Could not add'); });
  }
  function togglePicker(card) {
    if (!card) return;
    var pick = card.querySelector('.ig-rd-sizepick');
    if (!pick) return;
    document.querySelectorAll('.ig-rd-sizepick.is-open').forEach(function (p) { if (p !== pick) p.classList.remove('is-open'); });
    pick.classList.toggle('is-open');
  }

  /* ---------- card image click → navigate (media is a <div>, not an <a>,
       so quick-add/heart <button>s aren't nested in a link) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('button, a, [role="button"], .ig-rd-sizepick')) return;
    var media = e.target.closest('.ig-rd-card__media');
    if (!media) return;
    var card = media.closest('.ig-rd-card');
    if (card && card.getAttribute('data-product-url')) window.location.href = card.getAttribute('data-product-url');
  });

  /* ---------- keyboard activation for non-native controls ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target;
    if (!el || !el.matches) return;
    if (el.matches('[role="button"][tabindex], [role="menuitem"][tabindex], .ig-rd-acc__head, .ig-rd-delivery__head, [data-ig-sizeguide-open], .ig-rd-card__remove, .ig-rd-card__addbag')) {
      e.preventDefault();
      el.click();
    }
  });

  /* ---------- track the SG header height so redesign sticky elements
       (collection filter bar, PDP info) sit right below it ---------- */
  function setHeaderH() {
    // Use the VISIBLE bottom of whichever header is pinned at the top. The SG
    // sticky header is position:fixed (so offsetParent is null) and can sit a
    // few px above 0 — measuring its rect.bottom is what the sticky offset needs.
    var els = [document.getElementById('sticky-header'), document.getElementById('page-header')];
    var h = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el) continue;
      var c = getComputedStyle(el);
      if (c.display === 'none' || c.visibility === 'hidden' || c.opacity === '0') continue;
      var r = el.getBoundingClientRect();
      if (r.height < 10 || r.bottom <= 0) continue;
      if (c.position === 'fixed' || c.position === 'sticky') h = Math.max(h, Math.round(r.bottom));
      else if (r.top <= 2) h = Math.max(h, Math.round(r.bottom));
    }
    if (h > 0) document.documentElement.style.setProperty('--rd-header-h', h + 'px');
  }
  var hTick = false;
  function onHeaderChange() {
    if (hTick) return; hTick = true;
    requestAnimationFrame(function () { setHeaderH(); hTick = false; });
  }
  window.addEventListener('load', setHeaderH);
  window.addEventListener('resize', onHeaderChange);
  window.addEventListener('scroll', onHeaderChange, { passive: true });

  /* ---------- boot ---------- */
  function paintCardsLazily(cards) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { IG.paintCardIcons(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '300px 0px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { IG.paintCardIcons(c); });
    }
  }
  function boot() {
    setHeaderH();
    IG.syncWishBadges();
    IG.syncHearts();
    paintCardsLazily(document.querySelectorAll('.ig-rd-card'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // re-run after AJAX grid swaps
  document.addEventListener('ig-rd:grid-updated', boot);
})();
